import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { RouterModule } from '@angular/router';
import { FormsModule, NgModel, NgForm,ReactiveFormsModule }    from '@angular/forms';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';

// sentry
import * as Sentry from "@sentry/angular";

/*Materials*/
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatCardModule, MatToolbarModule, MatInputModule, MatNativeDateModule } from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
/*End-Materials*/

import { HttpClientModule } from '@angular/common/http';

/*Feature Modules */
import { AuthModule }             from './auth/auth.module';

/*Import your library*/ 
import {ClientRequest}            from '../ClientRequest';
import { Globals }                from '../Globals'

/*Import service*/ 
import { ElearningService }       from  './_services/elearning.service';
import { QuizSimulationService }  from  './_services/sim_quiz.service';
import { CourseService }          from  './_services/course.service';
import { PostService }            from  './_services/post.service'
import { ProfileService }         from  './_services/profile.service';
import { ApiService }             from  './_services/api.service';
import { AuthenticationService }  from  './_services/authentication.service';
import { CartService }            from  './_services/cart.service';

/*Lib 3*/
import { LazyLoadImagesModule } from 'ngx-lazy-load-images';
import { AuthGuard }  from  './_services/auth.guard';


import { AppComponent } from './app.component';
import { DialogComponent } from './_layout/dialog.component';

/*Pipe*/
import { PipeShareModule }  from  './_pipes/share.module';
import { LayoutModule } from './layout/layout.module';

@NgModule({
  declarations: [
    AppComponent, 
    DialogComponent
  ],
  imports: [
    LayoutModule,
    AuthModule,
    FormsModule,
    PipeShareModule,
    ReactiveFormsModule,
    LazyLoadImagesModule,
    MatIconModule,
    MatCardModule,
    MatToolbarModule,
    MatInputModule,
    MatMomentDateModule,
    MatRadioModule,
    MatDividerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatDatepickerModule, 
    MatFormFieldModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    BrowserModule.withServerTransition({appId: 'my-app'}),
  ],
  providers: [
    Globals,
    PostService,
    ElearningService,
    QuizSimulationService,
    CourseService,
    ApiService,
    ProfileService,
    AuthenticationService,
    CartService,
    ClientRequest,
    AuthGuard,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }
  ],
  entryComponents: [
    DialogComponent
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
